var exports = {
  "k": "xe564cbfb--9df8c0--container",
};

module.exports = exports;
